import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.87 11.5.57-.632L12 1.393 11.099.5 0 11.5l11.099 11 .901-.893-9.56-9.475z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "arrow_left"}) } }